export function jsx(
	tagName: string | ( ( attributes?: { [ key: string ]: any }, ...children: Array<HTMLElement | string> ) => HTMLElement | DocumentFragment ),
	attributes?: { [ key: string ]: any },
	...children: Array<HTMLElement | string>
): HTMLElement | DocumentFragment {
	if ( typeof tagName === 'function' ) return tagName( attributes, ...children );

	if ( !tagName || typeof tagName !== 'string' ) {
		throw new Error( 'Invalid tag name' );
	}

	if ( typeof attributes === 'undefined' || attributes === null ) {
		attributes = {};
	}

	let element = document.createElement( tagName );

	for ( const [ key, value ] of Object.entries( attributes ) ) {
		switch ( key ) {

			// Attributes
			default:
				element.setAttribute( key, value );
				break;

			// Object Properties
			case 'style':
				Object.assign( element[ key ], value );
				break;

			// Scalar properties
			case 'className':
				element[ key ] = value;
				break;

			case 'classList':
				element.classList.add( ...value.filter( String ) );
				break;

		}
	}

	for ( let child of children ) {
		if ( child instanceof HTMLElement ) {
			element.appendChild( child );
		} else if ( typeof child === 'string' ) {
			element.appendChild( document.createTextNode( child ) );
		}
	}

	return element;
}
